import { useCallback } from 'react';
import { useTrackUsageContextStandalone } from '../../usage-tracking/contexts/TrackUsageContext';
export const useTrackAvailabilityClicked = () => {
  const trackEvent = useTrackUsageContextStandalone();
  return useCallback(isOpened => {
    const action = isOpened ? 'opened availability popover' : 'closed availability popover';
    trackEvent('routing', 'availability clicked', {
      action
    });
  }, [trackEvent]);
};